import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor(
    private updates: SwUpdate,
    private appRef: ApplicationRef
  ) {
    if (!this.updates.isEnabled) {
      console.log(
        'Service worker is not enabled or not supported by the browser'
      );
      return;
    }

    this.updates.versionUpdates.subscribe((event) => {
      switch (event.type) {
        case 'VERSION_DETECTED':
          console.log('Downloading new app version:', event.version.hash);
          break;
        case 'VERSION_READY':
          console.log('Current app version:', event.currentVersion.hash);
          console.log(
            'New app version ready for use:',
            event.latestVersion.hash
          );
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(
            'Failed to install app version:',
            event.version.hash,
            event.error
          );
          break;
      }
    });

    this.checkForUpdate();
  }

  private checkForUpdate() {
    // Allow the app to stabilize first, before starting polling for updates with `interval()`.
    const appIsStable$ = this.appRef.isStable.pipe(
      first((isStable) => isStable === true)
    );
    const everySixHours$ = interval(6 * 60 * 60 * 1000);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);
    everySixHoursOnceAppIsStable$.subscribe(() =>
      this.updates.checkForUpdate()
    );
  }
}
